var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / large / profile-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-/-large-/-active-/-profil",
    transform: "translate(-1210.000000, -14.000000)",
    stroke: "#1A1919",
    strokeWidth: 1.81818182
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1206.000000, 12.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-icon",
    transform: "translate(4.982603, 3.208073)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.017397,
    cy: 6.30670907,
    r: 6.30670907
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    transform: "translate(11.017397, 22.337270) rotate(-180.000000) translate(-11.017397, -22.337270) ",
    points: "0 16.97164 0 27.7028994 22.034794 27.7028994 22.034794 16.97164"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsProfile);
export default __webpack_public_path__ + "static/media/icons_profile.9afc8fab.svg";
export { ForwardRef as ReactComponent };